"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/chooseUsSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseUsSectionChooseFifteenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/choose-icon-5.svg" | "/Templates/Doccure/img/icons/choose-icon-6.svg" | "/Templates/Doccure/img/icons/choose-icon-7.svg" */
    src: string;
    /** Detected variants: "Compassionate, Judgment-Free Environment" | "Licensed and Experienced Professionals" | "Confidential and Secure Sessions" */
    h30Text: ReactNode;
    /** Detected variants: "Safe, supportive space to share openly without fear or judgment." | "Certified professionals providing expert care tailored to individual needs." | "Private, secure sessions ensuring confidentiality and complete peace of mind." */
    p0Text: ReactNode;
    /** Detected variants: "choose-description" | "why-choose-description" */
    className: string;
    /** Detected variants: "choose-item-fifteen wow fadeInUp" */
    divClassName?: string;
    /** Detected variants: "2s" */
    dataWowDuration?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid icon" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "choose-text" */
    div1ClassName?: string;
    /** Detected variants: "choose-title" */
    h30ClassName?: string;
};
export type HomeFifteenChooseUsSectionGeneratedProps = {
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseUsSectionChooseFifteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseUsSectionChooseFifteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "2s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/features/choose-img-1.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "2s" */
    sectionDiv0Div0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "Helping You Heal with" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    /** Default: "Care &" */
    sectionDiv0Div0Div1Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Understanding" */
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "about" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-img-two.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseUsSectionChooseFifteenFadeInUps: ChooseUsSectionChooseFifteenFadeInUpsItem[];
    chooseUsSectionChooseFifteenFadeInUpsItemWrapper?: (item: ChooseUsSectionChooseFifteenFadeInUpsItem, content: ReactNode) => ReactNode;
    chooseUsSectionChooseFifteenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseUsSectionChooseFifteenFadeInUpsImageVisible?: boolean;
    chooseUsSectionChooseFifteenFadeInUpsImageRenderer?: (item: ChooseUsSectionChooseFifteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    chooseUsSectionChooseFifteenFadeInUpsH3Visible?: boolean;
    chooseUsSectionChooseFifteenFadeInUpsH3Renderer?: (item: ChooseUsSectionChooseFifteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    chooseUsSectionChooseFifteenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseUsSectionChooseFifteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseUsSectionChooseFifteenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseUsSectionChooseFifteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFifteenChooseUsSectionGenerated: FC<HomeFifteenChooseUsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/features/choose-img-1.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0Div1Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div1Div0Div0H20H2Text = "Helping You Heal with",
    sectionDiv0Div0Div1Div0Div0H20H2Text2 = "Care &",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div0H20Span0SpanText = "Understanding",
    sectionImageWithBasePath0ImageAlt = "about",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-img-two.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0Div0ClassName,
    chooseUsSectionChooseFifteenFadeInUps,
    chooseUsSectionChooseFifteenFadeInUpsItemWrapper,
    chooseUsSectionChooseFifteenFadeInUpsRenderer,
    chooseUsSectionChooseFifteenFadeInUpsImageVisible,
    chooseUsSectionChooseFifteenFadeInUpsImageRenderer,
    chooseUsSectionChooseFifteenFadeInUpsH3Visible,
    chooseUsSectionChooseFifteenFadeInUpsH3Renderer,
    chooseUsSectionChooseFifteenFadeInUpsImageProps,
    chooseUsSectionChooseFifteenFadeInUpsH3Props,
}) => {
    return (
        <section className="section whychoose-section-fifteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="why-choose-img pe-5 d-none d-lg-block wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="why-choose-content">
                            <div className="section-header section-header-fifteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0Div0DivDataWowDuration}>
                                <div className="section-sub-title">{sectionDiv0Div0Div1Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                        <br />
                                        {sectionDiv0Div0Div1Div0Div0H20H2Text2}
                                        {" "}
                                        <span>{sectionDiv0Div0Div1Div0Div0H20Span0SpanText}</span>
                                    </h2>
                                ))}
                            </div>
                            {renderCollectionNode(
                                chooseUsSectionChooseFifteenFadeInUps,
                                (item: ChooseUsSectionChooseFifteenFadeInUpsItem) => (
                                    <div className={item.divClassName ?? "choose-item-fifteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "2s"} key={item.key}>
                                        <div className={item.div0ClassName ?? "choose-icon"}>
                                            {renderItemNode(chooseUsSectionChooseFifteenFadeInUpsImageVisible, chooseUsSectionChooseFifteenFadeInUpsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon"} {...(typeof chooseUsSectionChooseFifteenFadeInUpsImageProps === "function" ? chooseUsSectionChooseFifteenFadeInUpsImageProps(item) : (chooseUsSectionChooseFifteenFadeInUpsImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "choose-text"}>
                                            {renderItemNode(chooseUsSectionChooseFifteenFadeInUpsH3Visible, chooseUsSectionChooseFifteenFadeInUpsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "choose-title"} {...(typeof chooseUsSectionChooseFifteenFadeInUpsH3Props === "function" ? chooseUsSectionChooseFifteenFadeInUpsH3Props(item) : (chooseUsSectionChooseFifteenFadeInUpsH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p className={item.className}>{item.p0Text}</p>
                                        </div>
                                    </div>
                                ),
                                chooseUsSectionChooseFifteenFadeInUpsItemWrapper,
                                chooseUsSectionChooseFifteenFadeInUpsRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFifteenChooseUsSectionGenerated;
